import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b84ede8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "el-dialog__title" }, "Move Item", -1))
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = { class: "dt-card__body" }
const _hoisted_4 = { class: "list-wrapper active" }
const _hoisted_5 = {
  key: 0,
  class: "no-location-search-results"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No lists are available", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "no-location-search-results"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No lists match search", -1))
const _hoisted_13 = {
  key: 1,
  class: "no-location-search-results"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No lists are available", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_selection = _resolveComponent("selection")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.modelValue,
    "custom-class": "selection-modal list-selector",
    onClosed: _ctx.afterCloseHandler,
    "before-close": _ctx.handleClose
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode("Move an item from "),
        _createElementVNode("strong", null, _toDisplayString(_ctx.poppedUpList.name), 1),
        _createTextVNode(" to another list.")
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_16, [
        _createVNode(_component_el_button, { onClick: _ctx.closeModal }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          disabled: _ctx.listSelected,
          type: "primary",
          onClick: _ctx.onMove
        }, {
          default: _withCtx(() => [
            _createTextVNode("Move")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_selection, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("article", _hoisted_4, [
              (_ctx.sortedAvailableLists && !_ctx.sortedAvailableLists.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_input, {
                      class: "mb-3",
                      placeholder: "Search lists...",
                      modelValue: _ctx.listFilter,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listFilter) = $event))
                    }, null, 8, ["modelValue"]),
                    (_ctx.filteredLists && _ctx.filteredLists.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                          _createVNode(_TransitionGroup, { name: "swap-list" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLists, (list) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: list.id,
                                  onClick: ($event: any) => (_ctx.listClick(list)),
                                  class: _normalizeClass(["selection-modal__list-item", { selected: list.isSelected }])
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(list.name), 1)
                                ], 10, _hoisted_9))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.sortedAvailableLists && _ctx.listFilter)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("img", {
                                  src: require('../assets/images/Whats-Mirroring.png')
                                }, null, 8, _hoisted_11),
                                _hoisted_12
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        ], 64))
                  ], 64))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onClosed", "before-close"]))
}